import { GoalFilterDocument, ID } from '@griply/types';
import { getWeekStartsOn, processGoalsByFilterDocument } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export type Options = {
  customOrder?: ID[];
};

export const useGoalsByFilterDocument = (
  filterDocument: GoalFilterDocument | undefined,
  { customOrder }: Options,
) => {
  const sortedGoals = useSortedGoals();
  const user = useUser();
  const today = useToday();
  const taskCounts = useTaskCounts();
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(
    () =>
      processGoalsByFilterDocument(sortedGoals, filterDocument, {
        customOrder,
        today,
        weekStartsOn,
        taskCounts: taskCounts?.byGoalId,
        goalProgressCounts: taskCounts?.byGoalProgress,
      }),
    [
      customOrder,
      filterDocument,
      sortedGoals,
      today,
      weekStartsOn,
      taskCounts?.byGoalId,
      taskCounts?.byGoalProgress,
    ],
  );
};
